import { createFetchRequester } from '@algolia/requester-fetch'

import type { AlgoliaDomain } from '../../types'
import { useAlgoliaHost } from '../useAlgoliaHost/useAlgoliaHost'
import { useVertexAiSearch } from '../useVertexAiSearch/useVertexAiSearch'

export type { AlgoliaDomain }

type AlgoliaSearchOptions = {
  hosts: { url: string; protocol: string }[]
  headers: Record<string, string>
  requester: ReturnType<typeof createFetchRequester>
  timeouts: {
    connect: number
    read: number
    write: number
  }
}

export function useAlgoliaSearchOptions(
  domain: AlgoliaDomain,
  feature?: string,
): AlgoliaSearchOptions {
  const host = useAlgoliaHost()
  const vertexAi = useVertexAiSearch(feature)

  const serverOnlyHeaders: Record<string, string> = import.meta.server
    ? {
        'user-agent': 'bm-search-javascript-client',
      }
    : {}

  return {
    hosts: [
      {
        url: vertexAi.enabled ? vertexAi.hostUrl : host.url.value,
        protocol: vertexAi.enabled ? vertexAi.protocol : host.protocol,
      },
    ],
    headers: {
      'BM-Search-Domain': domain,
      ...serverOnlyHeaders,
    },
    requester: createFetchRequester({
      requesterOptions: { credentials: 'include' },
    }),
    timeouts: {
      // 2 seconds (more generous than default 1s for Cloudflare)
      connect: 2,
      // 10 seconds (double default 5s to handle Cloudflare overhead)
      read: 10,
      // 30 seconds (keep default for indexing operations)
      write: 30,
    },
  }
}
